import { GfsOfferCalculationPage } from "@/services/backend/gfs/offer/components/offer-calculation-page";

export default function GfsOfferCalculationRoute() {
  return <GfsOfferCalculationPage />;
}
